import {Component, HostListener, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {DefaultDeviceCategory} from "../../../../model/default-device-category";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {AuthGuard} from "../../../../common/auth-guard.service";
import {CommonMessagesService} from "../../../../services/common-messages.service";
import {DefaultDeviceCategoriesService} from "../../../../services/default-device-categories.service";
import {noSpecialCharacters} from "../../../../shared/custom-validators";
import {DefaultDeviceCategoryPersistRequest} from "../../../../model/requests/default-device-category-persist-request";

@Component({
  selector: 'app-default-device-categories-form',
  templateUrl: './default-device-categories-form.component.html',
  styleUrls: ['./default-device-categories-form.component.scss']
})
export class DefaultDeviceCategoriesFormComponent implements OnInit {

  public category: DefaultDeviceCategory;

  public categoryForm: FormGroup;
  public persistingChanges: any;
  public formSuccess: boolean;

  public mode: 'create' | 'edit';
  public editInfo: { oldName: string };

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private i18n: TranslocoService,
              private authGuard: AuthGuard,
              private defaultDeviceCategoriesService: DefaultDeviceCategoriesService,
              private commonMessagesService: CommonMessagesService) {
  }

  ngOnInit(): void {
    this.route.url.subscribe(urlSegment => {
      if (urlSegment[1].path === 'new') {
        this.mode = 'create';
        this.loadCreationForm();
      } else {
        this.mode = 'edit';
        this.loadEditionForm(urlSegment[1].path);
      }
    });
  }

  loadCreationForm(): void {
    this.category = new DefaultDeviceCategory();
    this.createForm(this.category);
  }

  loadEditionForm(name): void {
    this.defaultDeviceCategoriesService.getDefaultDeviceCategory(name).toPromise().then(response => {
      this.category = response.defaultDeviceCategory;
      this.editInfo = {oldName: this.category.name};
      this.createForm(this.category);
    });
  }

  private createForm(category: DefaultDeviceCategory): void {
    this.categoryForm = this.formBuilder.group({
      name: [category.name, [Validators.required, Validators.maxLength(255), noSpecialCharacters]],
      description: [category.description, [Validators.maxLength(255)]]
    });
    this.categoryForm.markAsPending();
  }

  persistCategoryData(): void {
    if (!this.categoryForm.valid) {
      return;
    }

    this.persistingChanges = true;
    const persistData = this.buildPersistData();

    let promise;
    if (this.mode === 'create') {
      promise = this.defaultDeviceCategoriesService.createDefaultDeviceCategory(persistData).toPromise();
    } else {
      promise = this.defaultDeviceCategoriesService.editDefaultDeviceCategory(persistData).toPromise();
    }

    promise.then(response => {
      this.formSuccess = true;
      this.router.navigate([`/system/hw-catalog`], {state: {showView: 'device-categories'}});
    }).catch(error => {
      this.commonMessagesService.showPersistingError(this.mode, error, persistData.name);
      this.persistingChanges = false;
    });
  }

  public cancel(): void {
    this.router.navigate([`/system/hw-catalog`], {state: {showView: 'device-categories'}});
  }

  private buildPersistData(): DefaultDeviceCategoryPersistRequest {
    const formValue = this.categoryForm.getRawValue();
    return {
      name: formValue.name,
      description: formValue.description,
      oldName: this.mode === 'edit' ? this.editInfo.oldName : null
    };
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return this.formSuccess || this.categoryForm.untouched;
  }

}
